import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import HomeVariant from './pages/HomeVariant';
import { isVariantHost } from './utils/variant';
import Login from './pages/Login';
import Register from './pages/Register';
import Pricing from './pages/Pricing';
import Visualizer from './pages/Visualizer';
import Dashboard from './pages/Dashboard';
import Purchase from './pages/Purchase';
import Admin from './pages/Admin';
import Cro from './pages/Cro';
import Stats123 from './pages/Stats123';
import Charts123 from './pages/Charts123';
import Ads from './pages/Ads';


import DailyBonus from './components/DailyBonus';
import Booster from './components/Booster';
import Tools from './components/Tools';
import Charts from './components/Charts';
import Settings from './components/Settings';
import Magnet from './components/Magnet';
import Upgrade from './components/Upgrade';
import './index.css';
import Analytics from './components/Analytics';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/Refund';
import CancelPortal from './pages/CancelPortal';
import RefillPortal from './pages/RefillPortal';
import Mody from './pages/Mody';
import FiftyOff from './pages/FiftyOff';




import Jobs from './pages/Jobs';
import Agent from './pages/Agent';
function App() {
	const userToken = localStorage.getItem('accessToken');
		if (userToken) {
			try {
		  const tokenExpiry = JSON.parse(atob(userToken.split('.')[1])).exp;
		  const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
	  
		  // Refresh the token 5 minutes before it expires
		  console.log(tokenExpiry - currentTime)
			} catch (err) {
				console.log(err)
			}
		}
  return (
    <Router>
      <Routes>
        {/* A/B test: visitors from the variant domain (startviralgpt.com) get the
            cloned landing page; everyone else gets the normal home page. */}
        <Route path="/" element={isVariantHost ? <HomeVariant /> : <Home />} />
        <Route path="/login" element={<Login />} />
		<Route path="/register" element={<Register />} />
		<Route path="/pricing" element={<Pricing />} />
		<Route path="/50off" element={<FiftyOff />} />
		<Route path="/visualizer" element={<Visualizer />} />
		<Route path="/register" element={<Register />} />
		<Route path="/terms-of-service" element={<TermsOfService/>}></Route>
		<Route path="/privacy-policy" element={<PrivacyPolicy/>}></Route>
		<Route path="/refund" element={<RefundPolicy/>}></Route>
		<Route path="/refund-policy" element={<RefundPolicy/>}></Route>
		<Route path="/cancel" element={<CancelPortal/>}></Route>
		<Route path="/refill" element={<RefillPortal/>}></Route>

		<Route path="/agent" element={<Agent/>}></Route>
		<Route path="/jobs" element={<Jobs/>}></Route>
		<Route path="/mody/432qewd432qj43j4j4j5jn665560" element={<Mody/>}></Route>

		{/* Admin Route */}
        <Route path="/admin123" element={<Admin />} />
        <Route path="/cro" element={<Cro />} />
        <Route path="/stats123" element={<Stats123 />} />
        {/* /hadi — same page, second URL */}
        <Route path="/hadi" element={<Stats123 />} />
        <Route path="/charts123" element={<Charts123 />} />
        <Route path="/ads" element={<Ads />} />
		
        {/* Dashboard Layout */}
        <Route path="/dashboard" element={<Dashboard />}>
		{/* Redirect to /dashboard/magnet by default */}
		<Route index element={<Navigate to="magnet" replace />} /> 
			<Route path="upgrade" element={<Upgrade />} /> {/* /dashboard/upgrade */}
			<Route path="magnet" element={<Magnet />} /> {/* /dashboard/magnet */}
			<Route path="booster" element={<Booster />} /> {/* /dashboard/booster */}
			<Route path="tools" element={<Tools />} /> {/* /dashboard/tools */}
			<Route path="bonus" element={<DailyBonus />} /> {/* /dashboard/bonus */}
			<Route path="charts" element={<Charts />} /> {/* /dashboard/charts */}
			<Route path="settings" element={<Settings />} /> {/* /dashboard/settings */}
		</Route>
        {/* Fallback Route */}
        {/* <Route path="*" element={<h1>Page Not Found</h1>} /> */}
      </Routes>
        {/* Add other routes as needed */}
     
	  
    </Router>
  );
}

export default App;
